import {
  COUPON_SCOPE_CHANNEL,
  COUPON_SELECTION_TYPE,
} from './../../../utils/enum';

export const SELECTION_TYPE_OPTIONS = [
  { id: COUPON_SELECTION_TYPE.ENTER_CODE, name: 'Nhập mã' },
  { id: COUPON_SELECTION_TYPE.SELECTABLE, name: 'Cho khách chọn' },
];

export const SELECTABLE_CHANNEL_ERROR =
  'Coupon cho khách chọn chỉ áp dụng cho kênh Online!';

export const SELECTABLE_CODE_COUNT_ERROR =
  'Coupon cho khách chọn chỉ được có đúng 1 mã!';

export const CHANNEL_REQUIRED_ERROR = 'Vui lòng chọn kênh áp dụng!';

// Kênh "Offline & Online" (BOTH) bị ẩn khỏi form cho mọi coupon (Bổ sung 02) — chỉ UI
const CHANNEL_OPTIONS = [
  { id: COUPON_SCOPE_CHANNEL.OFFLINE, name: 'Offline' },
  { id: COUPON_SCOPE_CHANNEL.ONLINE, name: 'Online' },
];

const LEGACY_BOTH_OPTION = {
  id: COUPON_SCOPE_CHANNEL.BOTH,
  name: 'Offline & Online',
};

// Chương trình cũ đang là BOTH: giữ option để hiển thị đúng giá trị; đổi sang kênh khác thì option biến mất
export const getChannelOptions = (currentChannel) =>
  Number(currentChannel) === COUPON_SCOPE_CHANNEL.BOTH
    ? [LEGACY_BOTH_OPTION, ...CHANNEL_OPTIONS]
    : CHANNEL_OPTIONS;

// Chỉ kênh Online mới được chọn "Cho khách chọn" (AC-25)
export const isOnlineChannel = (applyChanel) =>
  Number(applyChanel) === COUPON_SCOPE_CHANNEL.ONLINE;

export const isSelectable = (selectionType) =>
  Number(selectionType) === COUPON_SELECTION_TYPE.SELECTABLE;

// Danh sách cho chọn chỉ hiển thị trên website ⇒ "Cho khách chọn" chỉ kênh Online (AC-12)
export const isSelectableOnInvalidChannel = (selectionType, applyChanel) =>
  isSelectable(selectionType) &&
  Number(applyChanel) !== COUPON_SCOPE_CHANNEL.ONLINE;

// "Cho khách chọn" chỉ được có đúng 1 mã (AC-24); "Nhập mã" không bị ràng buộc
export const isSelectableWithInvalidCodeCount = (selectionType, details) =>
  isSelectable(selectionType) && (details || []).length !== 1;
